export default __webpack_public_path__ + "static/media/containerdPush.8c201434.svg";